import React from 'react';
import {
  Building2, LayoutTemplate, Inbox, ReceiptText, BarChart3, Search,
  Users, Star, CheckCircle, TrendingUp, Shield, Images
} from 'lucide-react';

export const NAV_GROUPS = [
  {
    label: 'Venue Pages',
    items: [
      { key: 'venues', label: 'All Venue Pages', icon: Building2 },
      { key: 'media', label: 'Media Library', icon: Images },
      { key: 'homepage', label: 'Homepage CMS', icon: LayoutTemplate }
    ]
  },
  {
    label: 'Leads & Enquiries',
    items: [
      { key: 'leads', label: 'All Leads', icon: Inbox },
      { key: 'estimates', label: 'Estimates & Quotes', icon: ReceiptText }
    ]
  },
  {
    label: 'Venue Intelligence',
    items: [
      { key: 'analytics', label: 'Analytics', icon: BarChart3 },
      { key: 'searches', label: 'Search Insights', icon: Search },
      { key: 'users', label: 'Users', icon: Users },
      { key: 'visit-reports', label: 'Visit Reports', icon: Star },
      { key: 'verification', label: 'Verification', icon: CheckCircle },
      { key: 'top-venues', label: 'Top Venues', icon: TrendingUp },
      { key: 'security', label: 'Security', icon: Shield }
    ]
  }
];

export const AdminSidebar = ({ active, onSelect }) => (
  <>
    {/* Mobile: grouped dropdown */}
    <div className="lg:hidden mb-4">
      <select
        value={active}
        onChange={e => onSelect(e.target.value)}
        className="w-full h-11 rounded-lg border border-stone-200 bg-white px-3 text-sm"
        data-testid="admin-nav-mobile-select"
      >
        {NAV_GROUPS.map(g => (
          <optgroup key={g.label} label={g.label}>
            {g.items.map(it => <option key={it.key} value={it.key}>{it.label}</option>)}
          </optgroup>
        ))}
      </select>
    </div>

    {/* Desktop: grouped sidebar */}
    <aside className="hidden lg:block w-60 shrink-0">
      <div className="sticky top-24 space-y-6" data-testid="admin-sidebar">
        {NAV_GROUPS.map(g => (
          <div key={g.label}>
            <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-stone-400 px-3 mb-2">{g.label}</p>
            <div className="space-y-0.5">
              {g.items.map(it => {
                const Icon = it.icon;
                const isActive = active === it.key;
                return (
                  <button
                    key={it.key}
                    onClick={() => onSelect(it.key)}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-left transition-colors ${isActive ? 'bg-[#1A3626] text-white font-medium' : 'text-stone-600 hover:bg-stone-100'}`}
                    data-testid={`admin-nav-${it.key}`}
                  >
                    <Icon className="w-4 h-4 shrink-0" />
                    {it.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </aside>
  </>
);
